import { renderDjotToHtml } from '@/lib/djot'
import { tagNameEquals } from '@/lib/tag'
import { Event } from '@nostr/tools/wasm'
import { useAsync } from 'react-use'
import { useMemo } from 'react'
import { usePrimaryPage, useSecondaryPage } from '@/PageManager'

const BECH32_PREFIXES = ['npub1', 'nprofile1', 'nevent1', 'naddr1', 'note1']

export default function WikiArticle({ event, className }: { event: Event; className?: string }) {
  const title = useMemo(() => event.tags.find(tagNameEquals('title'))?.[1], [event])
  const summary = useMemo(() => event.tags.find(tagNameEquals('summary'))?.[1], [event])
  const { navigate } = usePrimaryPage()
  const { push } = useSecondaryPage()

  const {
    value: html,
    loading,
    error
  } = useAsync(() => renderDjotToHtml(event.content), [event.content])

  const onClick = (e: React.MouseEvent) => {
    const target = e.target as HTMLElement
    const anchor = target.closest('a')
    if (!anchor) return
    const href = anchor.getAttribute('href') || ''
    if (href.startsWith('nostrwiki:')) {
      e.preventDefault()
      const d = href.slice('nostrwiki:'.length)
      navigate('search', { input: `kind:30818 #d:${d}` })
      return
    }
    if (BECH32_PREFIXES.some((p) => href.startsWith(p))) {
      e.preventDefault()
      push(`/${href}`)
    }
  }

  return (
    <div
      className={`prose prose-zinc max-w-none dark:prose-invert break-words overflow-wrap-anywhere ${className || ''}`}
    >
      <h1 className="break-words">{title || event.tags.find(tagNameEquals('d'))?.[1]}</h1>
      {summary && (
        <blockquote>
          <p className="break-words">{summary}</p>
        </blockquote>
      )}
      {loading && <p className="text-muted-foreground">Loading…</p>}
      {error && <pre className="whitespace-pre-wrap">{event.content}</pre>}
      {html && (
        <div dangerouslySetInnerHTML={{ __html: html }} onClick={onClick} className="cursor-auto" />
      )}
    </div>
  )
}
